module.exports = {
  messages: {
    CN: {
      input: '请输入',
      select: '请选择',
      name: '仓库名',
      domain: '仓库域名',
      manager: '仓库管理员',
      approval: '审批人员',
      date: '生效日期',
      type: '仓库类型'
    },
    HK: {
      input: '請輸入',
      select: '請選擇',
      name: '倉庫名',
      domain: '倉庫域名',
      manager: '倉庫管理員',
      approval: '審批人員',
      date: '生效日期',
      type: '倉庫類型',
    },
    US: {
      input: 'Please enter',
      select: 'Please select',
      name: 'Repository Name',
      domain: 'Repository Domain',
      manager: 'Repository Manager',
      approval: 'Approval Person',
      date: 'Effective Date',
      type: 'Repository Type',
    }
  }
}
